<div #quillContainer></div>

<!-- Clear Text Confirmation Modal -->
<ng-template #clearTextModal let-modal>
    <div class="modal-body text-center py-4">
      <p class="fw-bold fs-5 mb-3">{{language.areYouSure}}</p>
    </div>
    <div class="modal-footer justify-content-center gap-2">
      <button type="button" class="btn btn-secondary btn-sm px-4" (click)="modal.close('yes')">{{language.yes}}</button>
      <button type="button" class="btn btn-danger btn-sm px-4" (click)="modal.dismiss('no')">{{language.no}}</button>
    </div>
  </ng-template>